// Só aceitamos links https de serviços de arquivo conhecidos (evita abrir endereços maliciosos).
const HOSTS = ['drive.google.com', 'docs.google.com', 'onedrive.live.com', '1drv.ms', 'sharepoint.com'];

export function validarLink(url: string) {
  try {
    const u = new URL(url.trim());
    if (u.protocol !== 'https:') return false;
    const h = u.hostname.toLowerCase();
    return HOSTS.some(x => h === x || h.endsWith('.' + x));
  } catch { return false; }
}
